import React from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';

const ChatTable = ({ children }) => (
    <div className="chat-table-wrapper">
        <table className="table table-sm">{children}</table>
    </div>
);

const ChatList = ({ children }) => <ul className="chat-list">{children}</ul>;

const MessageBody = ({ text }) => {
    if (!text) {
        return null;
    }

    return (
        <ReactMarkdown
            remarkPlugins={[gfm]}
            components={{
                p: 'p',
                ul: ChatList,
                ol: 'ol',
                li: 'li',
                table: ChatTable,
                thead: 'thead',
                tbody: 'tbody',
                tr: 'tr',
                th: 'th',
                td: 'td',
                a: 'a',
                code: 'code',
                pre: 'pre',
                strong: 'strong',
                em: 'em'
            }}
        >
            {text}
        </ReactMarkdown>
    );
};

export default MessageBody;
